import { useLoadingIndicatorDisappearsTelemetry } from '@makemydeal/dr-shared-ui-utils';

import { useShowroomLoadingIndicatorAttributes } from './useShowroomLoadingIndicatorAttributes';

/**
 * Convenience wrapper (US2078790) so each Showroom flow only needs one call instead of composing
 * `useShowroomLoadingIndicatorAttributes` + `useLoadingIndicatorDisappearsTelemetry` itself.
 */
export const useShowroomLoadingIndicatorDisappearsTelemetry = (
    disappearancePageActionName: string,
    hasLoadingIndicatorDisappeared: boolean,
    additionalAttributes?: Record<string, unknown>
): void => {
    const attributes = useShowroomLoadingIndicatorAttributes();
    useLoadingIndicatorDisappearsTelemetry(disappearancePageActionName, hasLoadingIndicatorDisappeared, {
        ...attributes,
        ...additionalAttributes
    });
};
